export { DrillPageHeaderTexts } from "#drill-page-header-texts";
export type { DrillPageHeaderTextsVariant } from "#drill-page-header-texts";
